<template>
  <div class="flex flex-center flex-col">
    <div class="bg-white p-8 flex flex-center flex-col" style="width: min(90%, 400px); margin: 10vh auto;">
      <h1 class="text-xl font-bold top-2">Login</h1>
      <input type="text" v-model="username" placeholder="Enter username" class="admin-input"/>
      <input type="password" v-model="password" placeholder="Enter password" class="admin-input"/>
      <button @click="login" class="btn btn-light">Login</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "vue3-toastify";

export default {
  name: "AdminLogin",
  data() {
    return {
      username: null,
      password: null,
      router: null
    };
  },
  created() {
    this.router = this.$router;
  },
  methods: {
    async login() {
      try {
        if(this.username === null || this.username === '') {
          toast.error('Enter username.', { icon: false });
        } else if(this.password === null || this.password === '') {
          toast.error('Enter password.', { icon: false });
        } else {
          // Make the POST request with FormData
          const response = await axios.post(process.env.VUE_APP_API_BASE + "/login", {username:this.username, password: this.password});

          // Check if the response is successful
          if(response.status === 200 && response.data?.token) {
            localStorage.setItem("token", response.data.token);
            this.router.push('/admin/orders');
          }

          if (response.data.level === 'warning') {
            response.data.messages.forEach(msg => {
              toast.warning(msg, { icon: false });
            });
          } else if (response.data.level === 'error') {
            response.data.messages.forEach(msg => {
              toast.error(msg, { icon: false });
            });
          }
        }
      } catch (error) {
        // Handle error
        toast.error('There was an unexpected error.\n Try again.', { icon: false });
        console.error(error);
      }
    }
  }
};
</script>
